import React from 'react';
import { connect } from 'react-redux';
import { PatientCareCenterNoteSection } from 'PatientCareCenter/Note';
import styles from './Common.module.css';
import { getPanels } from '_helpers';
import {
    PatientCareCenterNoteObjectiveMcKenzieSinglePanel,
    PatientCareCenterNoteObjectiveMcKenzieTriplePanel
} from 'PatientCareCenter/Note/Objective/ROM';
import { ROMMcKenzieProvisionalClassification } from './McKenzieClassification'


const components = {
    ROMMcKenzieProvisionalClassification
}

class PatientCareCenterNoteObjectiveMcKenzie extends React.Component {


    renderChild(name, mopno) {
        const Child = components[name];
        return Child === undefined ? <span key={name} mopno={mopno} /> : <Child key={name} mopno={mopno} />;
    }

    renderTestMovementHeader() {
        return (
            <span>
                <div className={styles.row}>
                    <div className={styles.flag} />
                    <div className={styles.mckenzie_label} />
                    <div className={styles.mckenzie_headers}>Symptoms During Testing</div>
                    <div className={styles.mckenzie_headers}>Symptoms After Testing</div>
                    <div className={styles.mckenzie_headers}>Mechanical Response</div>
                </div>
            </span>
        );
    }

    render() {
        if (this.props.totalPanelCount > 0) {
            return (
                <PatientCareCenterNoteSection id='obj_mckenzie' name='McKenzie Evaluation' level={2}>

                    {this.props.moveLossPanels.length > 0 &&
                        <PatientCareCenterNoteSection id='obj_mckenzie_moveloss' name='Movement Loss' level={3}>

                            {
                                Object.keys(this.props.moveLossPanels)
                                    .map(key => {
                                        return (<PatientCareCenterNoteObjectiveMcKenzieSinglePanel key={this.props.moveLossPanels[key].MOPNO} panelId={this.props.moveLossPanels[key].MOPNO} />);
                                    })

                            }
                        </PatientCareCenterNoteSection>
                    }

                    {this.props.preTestPanelCount > 0 &&
                        <PatientCareCenterNoteSection id='obj_mckenzie_testmove' name='Test Movements' level={3}>

                            {this.props.preTestSitPanels.length > 0 &&
                                <PatientCareCenterNoteSection id='obj_mckenzie_pretestsit' name='Pre-Test Symptoms in Sitting' level={4}>
                                    {this.renderTestMovementHeader()}
                                    {
                                        Object.keys(this.props.preTestSitPanels)
                                            .map(key => {
                                                return (<PatientCareCenterNoteObjectiveMcKenzieTriplePanel key={this.props.preTestSitPanels[key].MOPNO} panelId={this.props.preTestSitPanels[key].MOPNO} />);
                                            })

                                    }
                                </PatientCareCenterNoteSection>
                            }

                            {(this.props.preTestLiePanels.length > 0 || this.props.preTestLie2Panels.length > 0) &&
                                <PatientCareCenterNoteSection id='obj_mckenzie_pretestlie' name='Pre-Test Symptoms in Lying' level={4}>
                                    {this.renderTestMovementHeader()}
                                    {
                                        Object.keys(this.props.preTestLiePanels)
                                            .map(key => {
                                                return (<PatientCareCenterNoteObjectiveMcKenzieTriplePanel key={this.props.preTestLiePanels[key].MOPNO} panelId={this.props.preTestLiePanels[key].MOPNO} />);
                                            })

                                    }
                                    {
                                        Object.keys(this.props.preTestLie2Panels)
                                            .map(key => {
                                                return (<PatientCareCenterNoteObjectiveMcKenzieTriplePanel key={this.props.preTestLie2Panels[key].MOPNO} panelId={this.props.preTestLie2Panels[key].MOPNO} />);
                                            })

                                    }
                                </PatientCareCenterNoteSection>
                            }

                            {this.props.preTestStandPanels.length > 0 &&
                                <PatientCareCenterNoteSection id='obj_mckenzie_preteststand' name='Pre-Test Symptoms in Standing' level={4}>
                                    {this.renderTestMovementHeader()}
                                    {
                                        Object.keys(this.props.preTestStandPanels)
                                            .map(key => {
                                                return (<PatientCareCenterNoteObjectiveMcKenzieTriplePanel key={this.props.preTestStandPanels[key].MOPNO} panelId={this.props.preTestStandPanels[key].MOPNO} />);
                                            })

                                    }
                                </PatientCareCenterNoteSection>
                            }

                            {/* {this.props.preTestLie2Panels.length > 0 &&
                                <PatientCareCenterNoteSection id='obj_mckenzie_pretestlie2' name='Pre-Test Symptoms in Lying' level={4}>
                                    {this.renderTestMovementHeader()}
                                    {
                                        Object.keys(this.props.preTestLie2Panels)
                                            .map(key => {
                                                return (<PatientCareCenterNoteObjectiveMcKenzieTriplePanel key={this.props.preTestLie2Panels[key].MOPNO} panelId={this.props.preTestLie2Panels[key].MOPNO} />);
                                            })

                                    }
                                </PatientCareCenterNoteSection>
                            } */}

                            {this.props.ifReqPreTestPanels.length > 0 &&
                                <PatientCareCenterNoteSection id='obj_mckenzie_pretestifreq' name='If Required, Pre-Test Symptoms' level={4}>
                                    {this.renderTestMovementHeader()}
                                    {
                                        Object.keys(this.props.ifReqPreTestPanels)
                                            .map(key => {
                                                return (<PatientCareCenterNoteObjectiveMcKenzieTriplePanel key={this.props.ifReqPreTestPanels[key].MOPNO} panelId={this.props.ifReqPreTestPanels[key].MOPNO} />);
                                            })

                                    }
                                </PatientCareCenterNoteSection>
                            }

                        </PatientCareCenterNoteSection>
                    }

                    {
                        Object.keys(this.props.provClassPanels)
                            .map(key => {
                                return this.renderChild(this.props.provClassPanels[key].MOPNAME, this.props.provClassPanels[key].MOPNO);
                            })

                    }
                </PatientCareCenterNoteSection>
            );
        } else {
            return (<span />);
        }
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;

    let moveLossPanels = getPanels(noteId, 'ROMMcKenzie', 'MoveLoss');
    let preTestSitPanels = getPanels(noteId, 'ROMMcKenzie', 'PreTestSit');
    let preTestLiePanels = getPanels(noteId, 'ROMMcKenzie', 'PreTestLie');
    let preTestStandPanels = getPanels(noteId, 'ROMMcKenzie', 'PreTestStand');
    let preTestLie2Panels = getPanels(noteId, 'ROMMcKenzie', 'PreTestLie2');
    let ifReqPreTestPanels = getPanels(noteId, 'ROMMcKenzie', 'IfReqPreTest');
    let provClassPanels = getPanels(noteId, 'ROMMcKenzie', 'ProvClass');

    let totalPanelCount = moveLossPanels.length +
        preTestSitPanels.length +
        preTestLiePanels.length +
        preTestStandPanels.length +
        preTestLie2Panels.length +
        ifReqPreTestPanels.length +
        provClassPanels.length;

    let preTestPanelCount = preTestSitPanels.length +
        preTestLiePanels.length +
        preTestStandPanels.length +
        preTestLie2Panels.length +
        ifReqPreTestPanels.length;

    return {
        noteId: noteId,
        moveLossPanels: moveLossPanels,
        preTestSitPanels: preTestSitPanels,
        preTestLiePanels: preTestLiePanels,
        preTestStandPanels: preTestStandPanels,
        preTestLie2Panels: preTestLie2Panels,
        ifReqPreTestPanels: ifReqPreTestPanels,
        provClassPanels: provClassPanels,
        totalPanelCount: totalPanelCount,
        preTestPanelCount: preTestPanelCount
    };
}

const connectedPatientCareCenterNoteObjectiveMcKenzie = connect(mapStateToProps)(PatientCareCenterNoteObjectiveMcKenzie);
export { connectedPatientCareCenterNoteObjectiveMcKenzie as PatientCareCenterNoteObjectiveMcKenzie };

